<template>
  <div id="energy-router">
    <erengy-navigation></erengy-navigation>
    <div class="children-view">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import ErengyNavigation from "./EnergyNavigation.vue"
  export default{
    data(){
      return{

      }
    },
    components:{
      ErengyNavigation
    },
    created() {
    },
    mounted() {
      this.$store.state.HTMLminWidth = 1910
    },
    methods:{

    }
  }
</script>

<style scoped>
  #energy-router{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #f7f7f7;
  }
  .children-view{
    position: absolute;
    left: 208px;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #f7f7f7;
  }
</style>



// WEBPACK FOOTER //
// src/components/PublicAssembly/EnergyRouter.vue